module.exports = "/images/success.png?667c8c278ad71e4414e438d0477dea44";